import ReserveButton from "./reserve-button";

customElements.define("mx-reserve-button", ReserveButton);
